import {
  CameraIcon,
  ChatBubbleBottomCenterIcon,
  EllipsisVerticalIcon
} from "@heroicons/react/20/solid/index.js";
import { useState } from "react";
import UploadChecklistImage from "./UploadChecklistImage.js";
import { type ChecklistResponse } from "@swivu/client-api";
import ChecklistComment from "./ChecklistComment.js";
import { QueryClient } from "@tanstack/react-query";
import { DropdownMenu } from "../DropdownMenu.js";
import { useIsGummy } from "../../hooks/useGummyTheme.js";
import { cn } from "../../utils/cn.js";

type CheckItemMoreMenuProps = {
  queryClient: QueryClient;
  checklist_id: number;
  item: ChecklistResponse["items"][number];
  incrementImageCacheBuster: () => void;
};
const CheckItemMoreMenu = ({
  queryClient,
  checklist_id,
  item,
  incrementImageCacheBuster
}: CheckItemMoreMenuProps) => {
  const isGummy = useIsGummy();
  const [showItem, setShowItem] = useState<
    "uploadPicture" | "addComment" | undefined
  >(undefined);

  const handleSelect = (action: "uploadPicture" | "addComment") => {
    // This is a workaround to allow the dropdown to clean up pointer-events-none on the body when the modal is opened
    setTimeout(() => {
      setShowItem(action);
    }, 0);
  };

  return (
    <>
      <UploadChecklistImage
        queryClient={queryClient}
        item={item}
        isOpen={showItem === "uploadPicture"}
        handleClose={() => setShowItem(undefined)}
        incrementImageCacheBuster={incrementImageCacheBuster}
      />
      <ChecklistComment
        checklist_id={checklist_id}
        item={item}
        isOpen={showItem === "addComment"}
        handleClose={() => setShowItem(undefined)}
        queryClient={queryClient}
      />
      <DropdownMenu.Root>
        <DropdownMenu.Trigger
          className={cn(
            "mobile-pref-control-tight mobile-pref-checklist-menu-trigger",
            !isGummy && "rounded-md p-1"
          )}
        >
          <EllipsisVerticalIcon
            className={cn(
              "mobile-pref-control-icon mobile-pref-checklist-menu-icon h-6 w-6",
              isGummy ? "text-mono-600 dark:text-mono-300" : "text-mono-500"
            )}
          />
        </DropdownMenu.Trigger>
        <DropdownMenu.Content align="end" side="bottom">
          <DropdownMenu.Item onSelect={() => handleSelect("uploadPicture")}>
            <button className="mobile-pref-menu-item flex w-full items-center gap-4 text-left">
              <CameraIcon className={`mobile-pref-control-icon h-4 w-4`} />
              <span>{item.image_url ? "Change picture" : "Add picture"}</span>
            </button>
          </DropdownMenu.Item>
          <DropdownMenu.Item onSelect={() => handleSelect("addComment")}>
            <button className="mobile-pref-menu-item flex w-full items-center gap-4 text-left">
              <ChatBubbleBottomCenterIcon
                className={`mobile-pref-control-icon h-4 w-4`}
              />
              <span>Add message</span>
            </button>
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Root>
    </>
  );
};

export default CheckItemMoreMenu;
